export const getDetailAllUkm = [
	{
		id: 1,
		slug: 'FM',
		nama: 'Fordi Mapelar',
		logo: 'logo_fm.png',
		deskripsi: 'sebuah deskripsi untuk mendeskripsikan fordi mapelar',
		sekilas: 'sekilas ini digunakan untuk menceritakan tentang fordi mapelar',
		video_profile: 'https://youtu.be/nDTWFn30YHU',
		pesan: 'Ayo daftar di fordi mapelar!',
		tanggal_oprec: '10 Oktober 2021',
		link_oprec: 'www.fordimapelar.co.id',
		faq: [
			{
				question: 'Kapan oprec ?',
				answer: '22 Oktober – 25 Oktober',
			},
			{
				question: 'Kapan bedah buku ?',
				answer: '26 Oktober',
			},
			{
				question: 'Kapan bahas tokoh ?',
				answer: 'Setiap hari',
			},
		],
		galeri: [
			{
				nama_file: 'Foto1_FM.png',
			},
			{
				nama_file: 'Foto2_FM.png',
			},
			{
				nama_file: 'Foto3_FM.png',
			},
			{
				nama_file: 'Foto_FM4.png',
			},
		],
		kegiatan: [
			{
				nama_kegiatan: 'Berpikir',
				deskripsi: 'Memikirkan tanda-tanda yang ada di alam ini',
			},
			{
				nama_kegiatan: 'Bedah Buku',
				deskripsi: 'Membedah seluruh substansi dari buku',
			},
			{
				nama_kegiatan: 'Ulas Tokoh',
				deskripsi: 'Mengulas Tokoh Nasional',
			},
		],
		kriteria: ['Olahraga', 'Penalaran'],
		prestasi: [
			{
				nama_prestasi: 'Juara 1 Berpikir Kritis',
			},
			{
				nama_prestasi: 'Juara 1 Mencintai Tokoh',
			},
			{
				nama_prestasi: 'Juara 1 Membedah buku Filsafat',
			},
			{
				nama_prestasi: 'Juara 3 Menulis Esai',
			},
		],
		sosmed: [
			{
				platform: 'Instagram 1',
				link: 'i_fordimapelar',
			},
			{
				platform: 'Twitter',
				link: 't_fordimapelar',
			},
			{
				platform: 'Line',
				link: 'l_fordimapelar',
			},
		],
	},
	{
		id: 2,
		slug: 'UAB',
		nama: 'Unit Aktivis Band',
		logo: 'logo_uab.png',
		deskripsi: 'sebuah deskripsi untuk mendeskripsikan UAB',
		sekilas: 'sekilas ini digunakan untuk menceritakan tentang UAB',
		video_profile: 'https://youtu.be/nDsFFK80YHU',
		pesan: 'Ayo daftar di uab!',
		tanggal_oprec: '10 Oktober 2021',
		link_oprec: 'www.uab-indonesia.co.id',
		faq: [
			{
				question: 'Jenis guitar yang ada ?',
				answer: 'Yamaha',
			},
			{
				question: 'Nama Ketua ?',
				answer: 'Saiful',
			},
			{
				question: 'Jadwal Latihan ?',
				answer: 'Setiap hari',
			},
		],
		galeri: [
			{
				nama_file: 'Foto1_UAB.png',
			},
			{
				nama_file: 'Foto2_UAB.png',
			},
			{
				nama_file: 'Foto3_UAB.png',
			},
		],
		kegiatan: [
			{
				nama_kegiatan: 'GIGS Hunting',
				deskripsi: 'Mencari info gigs dipenjuru negeri',
			},
			{
				nama_kegiatan: 'Ngeband',
				deskripsi: 'Ngeband disetiap rumah',
			},
		],
		kriteria: ['Khusus', 'Kesejahteraan'],
		prestasi: [
			{
				nama_prestasi: 'Juara 1 Band 2018',
			},
			{
				nama_prestasi: 'Juara 1 Drumer Terfavorit',
			},
			{
				nama_prestasi: 'Juara 2 Guitaris Terfavorit',
			},
		],
		sosmed: [
			{
				platform: 'Instagram 1',
				link: 'i_uab',
			},
			{
				platform: 'Twitter',
				link: 't_uab',
			},
			{
				platform: 'Line',
				link: 'l_uab',
			},
		],
	},
	{
		id: 3,
		slug: 'RKIM',
		nama: 'Remaja Karya Ilmiah Mahasiswa',
		logo: 'logo_rkim.png',
		deskripsi: 'sebuah deskripsi untuk mendeskripsikan RKIM',
		sekilas: 'sekilas ini digunakan untuk menceritakan tentang RKIM',
		video_profile: 'https://youtu.be/Hs8d7a8i3H8',
		pesan: 'Ayo daftar di rkim!',
		tanggal_oprec: '10 Oktober 2021',
		link_oprec: 'rkim-indonesia.co.id',
		faq: [
			{
				question: 'Genre Buku ?',
				answer: 'SCI-FI',
			},
			{
				question: 'Nama Pembina ?',
				answer: 'Bp. Ahmad Subagyo',
			},
			{
				question: 'Donatur Buku ?',
				answer: 'Perpustakaan Malang',
			},
		],
		galeri: [
			{
				nama_file: 'Foto1_RKIM.png',
			},
			{
				nama_file: 'Foto2_RKIM.png',
			},
			{
				nama_file: 'Foto3_RKIM.png',
			},
			{
				nama_file: 'Foto4_RKIM.png',
			},
		],
		kegiatan: [
			{
				nama_kegiatan: 'Menulis Essai',
				deskripsi: '-',
			},
			{
				nama_kegiatan: 'Bedah Karya Ilmiah',
				deskripsi: '-',
			},
			{
				nama_kegiatan: 'Bedah Jantung Buku',
				deskripsi: '-',
			},
		],
    kriteria: ['Olahraga', 'Kesenian', 'Penalaran', 'Kesejahteraan'],
		prestasi: [
			{
				nama_prestasi: 'Juara 1 Bedah Karya Ilmiah 2021',
			},
		],
		sosmed: [
			{
				platform: 'Instagram 1',
				link: 'i_rkim_ub',
			},
			{
				platform: 'Twitter',
				link: 't_rkim_ub',
			},
			{
				platform: 'Line',
				link: 'l_rkim_ub',
			},
		],
	},
];


export const loading = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
export const versions = 1;